import { startTransition, useEffect, useRef, useState } from "react";
// import SlotCounter from "react-slot-counter";

const FooterTicker = () => {
    const [dollars, setDollars] = useState(() => {
        const savedDollars = localStorage.getItem('dollars');
        return savedDollars ? parseInt(savedDollars, 10) : 0;
    });

    const [cents, setCents] = useState(() => {
        const savedCents = localStorage.getItem('cents');
        return savedCents ? parseInt(savedCents, 10) : 0;
    });

    const [selectedDate] = useState(() => {
        const savedDate = localStorage.getItem('selectedDate');
        return savedDate ? new Date(savedDate) : new Date("2024-12-15T00:00:00Z");
    });

    const [showPSWF, setShowPSWF] = useState(false);

    const centsRef = useRef(cents);
    const dollarsRef = useRef(dollars);
    const lastPersistRef = useRef(Date.now());

    useEffect(() => {
        centsRef.current = cents;
    }, [cents]);

    useEffect(() => {
        dollarsRef.current = dollars;
    }, [dollars]);

    const secondsInMonth = 30 * 24 * 60 * 60; // Simplified to 30 days for now
    const targetAmount = 2500000
    const secondsPerDollar = secondsInMonth / targetAmount / 100; // Calculate the seconds for 1 cent

    useEffect(() => {
        let rafId = null;

        const runTick = () => {
            rafId = requestAnimationFrame(() => {
                const elapsedSeconds = Math.floor((Date.now() - selectedDate.getTime()) / 1000);

                const nextCents = Math.floor(elapsedSeconds / secondsPerDollar) % 100;
                const nextDollars = Math.floor(elapsedSeconds / (secondsPerDollar * 100));

                const valuesChanged = nextCents !== centsRef.current || nextDollars !== dollarsRef.current;

                if (valuesChanged) {
                    centsRef.current = nextCents;
                    dollarsRef.current = nextDollars;
                    startTransition(() => {
                        setCents(nextCents);
                        setDollars(nextDollars);
                    });
                }

                const now = Date.now();
                if (valuesChanged && now - lastPersistRef.current >= 15000) {
                    localStorage.setItem('dollars', nextDollars);
                    localStorage.setItem('cents', nextCents);
                    localStorage.setItem('selectedDate', selectedDate.toISOString());
                    lastPersistRef.current = now;
                }
            });
        };

        const interval = setInterval(runTick, 1000);
        runTick();

        return () => {
            clearInterval(interval);
            if (rafId) {
                cancelAnimationFrame(rafId);
            }
        };
    }, [selectedDate, secondsPerDollar]);

    // const formatNumber = (value) => {
    //     return value.toString().padStart(10, "0");
    // };

    const formatNumber = (value) => {
        return value.toLocaleString("en-US", { minimumIntegerDigits: 10, useGrouping: true });
    };

    const handleTickerClick = () => {
        setShowPSWF(true);
        setTimeout(() => {
            setShowPSWF(false);
        }, 3000); // Hide after 3 seconds
    };

    return (
        <div className={`overflow-x-hidden flex flex-col h-8 items-center justify-center w-full rounded cursor-pointer ${showPSWF ? 'bg-[#BDE6FF]' : 'bg-[#BDE6FF] px-[5px] py-[7px]'}`} onClick={handleTickerClick}>
            {showPSWF ? (
                <div className="flex items-center justify-center w-full h-full text-black font-bold text-[12px] md:text-[8px] lg:text-[14px]">
                    The Chaa Chingg User Pool
                </div>
            ) : (
                <div className="flex flex-row justify-center gap-1">
                    {/* {`${formatNumber(dollars)}.${cents.toString().padStart(2, "0")}`
                        .split("")
                        .map((char, index) => (
                            <div
                                key={index}
                                className="px-[3px] font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#38B6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]"
                            >
                                <p>{char}</p>
                            </div>
                        ))} */
                    }
                    {/* <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#38B6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        $
                    </p> */}
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        ,
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        ,
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        ,
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        3
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                    <p className="px-[3px] tr font-black flex items-center justify-center text-[12px] md:text-[8px] lg:text-[12px] text-black rounded-[2px] bg-[#BDE6FF] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                        0
                    </p>
                </div>
            )}
        </div>
    )
}

export default FooterTicker